import React from "react";
import PropTypes from "prop-types";
import { IconButton, Badge, Tooltip, Box, makeStyles } from "@material-ui/core";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  buttonWrapper: {
    display: "inline-flex",
    marginRight: theme.spacing(1.5),
    position: "relative",
  },
  filterButton: {
    padding: theme.spacing(0.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
  },
  filterButtonActive: {
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: (props) => `${props.clientColor}25`,
    },
  },
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: (props) => props.clientColor,
      color: "#fff",
      zIndex: 1,
    },
  },
}));

export default function FilterButton({
  onClick,
  activeFiltersCount,
  clientColor,
}) {
  const classes = useStyles({ clientColor });
  const { t } = useTranslation("translation", {
    keyPrefix: "rgm.cockpit.filters",
  });

  return (
    <Tooltip title={t("add_filters_tooltip")}>
      <Box
        display="inline-flex"
        style={{ position: "relative", marginRight: "16px" }}
      >
        <Badge
          badgeContent={activeFiltersCount}
          className={classes.badge}
          max={99}
        >
          <IconButton
            onClick={onClick}
            size="small"
            className={
              activeFiltersCount > 0
                ? classes.filterButtonActive
                : classes.filterButton
            }
            style={
              activeFiltersCount > 0
                ? {
                    border: `1px solid ${clientColor}`,
                    backgroundColor: `${clientColor}15`,
                    color: clientColor,
                  }
                : {}
            }
          >
            <FilterAltIcon fontSize="small" />
          </IconButton>
        </Badge>
      </Box>
    </Tooltip>
  );
}

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  activeFiltersCount: PropTypes.number,
  clientColor: PropTypes.string.isRequired,
};

FilterButton.defaultProps = {
  activeFiltersCount: 0,
};
